type Responsable = {
    id: number;
    cuit: string;
    nombre: string;
    idTipoResponsable: number;
    permiso: string;
    matricula: string;
    fechaExpedicion: string;
    fechaVencimiento: string;
    autorizacionIndividual: string;
    licenciaEspecial: number;
    titulo: string;
};

type Equipo = {
    id: number;
    marca: string;
    modelo: string;
    idTipoEquipo: number;
    idCaracteristica: number;
    idTipoRadiacion: number;
    actividad: string;
    radioisotopoFuente: string;
    idTipoFuente: number;
    potenciaKVP: number;
    potenciaMAP: number;
    potenciaMEV: number;
    procesamientoImagenes: number;
    idMetodoProcesamiento: number;
    observaciones: string;
    cuitDisometria: string;
    tipoDisometria: string;
    metodoDisometria: string;
    cantidadPersonalDisometria: number;
    responsables: Responsable[];
    sustancia: {
        id: number;
        descripcion: string;
    };
};

type ValidationResult = {
    isValid: boolean;
    missingFields: string[];
};

export function validateEquipmentState(equipo: Equipo): ValidationResult {
    const missingFields: string[] = [];

    const checkField = (value: any, fieldName: string) => {
        if (
            value === null ||
            value === undefined ||
            (typeof value === 'string' && value.trim() === '')
        ) {
            missingFields.push(fieldName);
        }
    };

    // General fields
    [
        'marca',
        'modelo',
        'idTipoEquipo',
        'idCaracteristica',
        'idTipoRadiacion',
        'actividad',
        // 'radioisotopoFuente',
        'idTipoFuente',
        'potenciaKVP',
        'potenciaMAP',
        'potenciaMEV',
        'procesamientoImagenes',
        'idMetodoProcesamiento',
        // 'observaciones',
        'cuitDisometria',
        'tipoDisometria',
        'metodoDisometria',
        'cantidadPersonalDisometria'
    ].forEach((key) => checkField((equipo as any)[key], key));

    // Responsables
    if (!Array.isArray(equipo.responsables) || equipo.responsables.length === 0) {
        missingFields.push('responsables (none provided)');
    } else {
        const responsable = equipo.responsables[0];
        if (!responsable) {
            missingFields.push('responsables[0] (empty)');
        } else {
            [
                'id',
                'cuit',
                'nombre',
                'idTipoResponsable',
                'permiso',
                'matricula',
                'fechaExpedicion',
                'fechaVencimiento',
                'autorizacionIndividual',
                'licenciaEspecial'
            ].forEach((key) => checkField((responsable as any)[key], `responsables[0].${key}`));
        }
    }

    return {
        isValid: missingFields.length === 0,
        missingFields
    };
}
